import React from "react";

import {
  AvailabilityBanner,
  PinIcon,
  QuantityStepper,
  StarRating,
  SupplierAvatar,
} from "./DetailBits";
import { formatDistanceKm, formatMoney } from "../detailMappers";

const MAX_QUANTITY = 10;

const OfferBuyBox = ({
  supplier,
  notice,
  quantity,
  inCart,
  busy,
  busyAction,
  onQuantityChange,
  onAdd,
  onBuy,
  onViewCart,
  onVisitStore,
}) => {
  const { name, price, originalPrice, currency, pricePerKg, inStock } = supplier;

  const blocked = Boolean(notice);
  const available = inStock !== false;

  const hasDiscount = Number.isFinite(originalPrice) && originalPrice > price;
  const percentOff = hasDiscount
    ? Math.round(((originalPrice - price) / originalPrice) * 100)
    : 0;

  const distance = Number.isFinite(supplier.distanceKm)
    ? `${formatDistanceKm(supplier.distanceKm)} away`
    : null;

  return (
    <section className="sy-buybox" aria-label="Your selection">
      <header className="sy-buybox-head">
        <SupplierAvatar name={name} logoUrl={supplier.logoUrl} size={44} />

        <div className="sy-buybox-identity">
          <span className="sy-buybox-eyebrow">Buying from</span>

          <button
            type="button"
            className="sy-buybox-store"
            onClick={onVisitStore}
            aria-label={`View ${name} store`}
          >
            {name}

            <svg viewBox="0 0 20 20" aria-hidden="true">
              <path d="M7.5 4l6 6-6 6" />
            </svg>
          </button>

          <span className="sy-buybox-meta">
            {supplier.totalRatings ? (
              <StarRating rating={supplier.rating} total={supplier.totalRatings} compact />
            ) : null}

            {distance && (
              <span className="sy-supplier-distance">
                <PinIcon />
                {distance}
              </span>
            )}
          </span>
        </div>
      </header>

      <div className="sy-buybox-price">
        <b>{formatMoney(price, currency)}</b>

        {hasDiscount && (
          <>
            <s>{formatMoney(originalPrice, currency)}</s>
            <em>{percentOff}% off</em>
          </>
        )}
      </div>

      <p className="sy-buy-meta">
        {Number.isFinite(pricePerKg) && (
          <span>{formatMoney(pricePerKg, currency)} per Kg</span>
        )}

        <span className={`sy-stock${available ? "" : " is-out"}`}>
          {available ? "In stock" : "Out of stock"}
        </span>
      </p>

      <AvailabilityBanner notice={notice} />

      <div className="sy-buybox-actions">
        {!available ? (
          <button type="button" className="sy-btn sy-btn-primary" disabled>
            Out of Stock
          </button>
        ) : inCart ? (
          <button type="button" className="sy-btn sy-btn-primary" onClick={onViewCart}>
            View Cart
          </button>
        ) : (
          <>
            <QuantityStepper
              value={quantity}
              max={MAX_QUANTITY}
              disabled={blocked || busy}
              onChange={onQuantityChange}
            />

            <button
              type="button"
              className="sy-btn sy-btn-outline"
              disabled={blocked || busy}
              onClick={onAdd}
            >
              {busy && busyAction === "add" ? "Adding…" : "Add to Cart"}
            </button>

            <button
              type="button"
              className="sy-btn sy-btn-primary"
              disabled={blocked || busy}
              onClick={onBuy}
            >
              {busy && busyAction === "buy" ? "Working…" : "Buy Now"}
            </button>
          </>
        )}
      </div>
    </section>
  );
};

export default OfferBuyBox;
